<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='该logo将在经销商端登陆、门店端登陆等公司/品牌宣传页面显示' :padding='false'></SmallSquare>
      <a-form class="m-t-20" ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- 基本信息 -->
        <a-form-item ref="" label="账号" name="">
          <p class="s_c333">{{form.account}}</p>
        </a-form-item>
        <a-form-item ref="" label="企业名称" name="">
          <p class="s_c333">{{form.company}}</p>
        </a-form-item>
        <a-form-item ref="" label="品牌名称" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.brand_name" />
            </a-col>
            <a-col :span="12">
              <p>最多20个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="LOGO上传" name="" help='
        （图片宽高要求比例1:1比例，建议尺寸：320*320）'>
          <material :groupType='1' :image="form.brand_logo" :max="1" v-on:handlechoose="(data)=>{form.brand_logo=data}"
            v-on:handledel="form.brand_logo=''" />
        </a-form-item>
        <a-form-item ref="" label="所属行业" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-select v-model:value="form.industry" placeholder="请选择所属行业">
                <a-select-option v-for='item in typeList' :key='item' :value="item">{{item}}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="管理员姓名" name="">
          <p class="s_c333">{{form.contact_name}}</p>
        </a-form-item>
        <a-form-item ref="" label="手机号码" name="">
          <p class="s_c333">{{form.contact_phone}}</p>
        </a-form-item>
        <a-form-item ref="" label="客服电话" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.clerk_phone" placeholder="请输入客服电话" />
            </a-col>
            <a-col :span="12">
              <a-tooltip placement="right">
                <template #title>
                  客服电话是消费者联系商家的方式之一，将显示在云店的相关交易页面。<br />此内容的填写有助于商家快速解决客户问题，防止出现商户纷争。
                </template>
                <QuestionCircleOutlined class="s_c376" />
              </a-tooltip>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="门店地址" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <selectCity class="m-r-20" :addressData='address' v-on:citychange='citychange'>
              </selectCity>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="详细地址" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.address" placeholder='请输入详细地址' />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="官方网站" name="">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-input v-model:value="form.website_url" placeholder='请输入官方网站' />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button style="width:100px" type="primary" v-has:informationAccountSet="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { getInfoDetail, setInfoUpdate, getIndustry } from "@/api/system";
  import { iscode } from "@/utils/app";
  import store from '@/store'
  // 初始化默认筛选项数值
  let defForm = {
    brand_name: '',
    province: '',
    city: '',
    region: '',
    address: '',
    website_url: '',
    industry: '',
    brand_logo: '',
    clerk_phone: ''
  }
  export default {
    components: { QuestionCircleOutlined },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        levelList: [],
        typeList: [],
        address: [],
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        rules: {
          store_code: [
            { required: true, message: '请输入门店编号' },
            { max: 20, message: '最多20个字', trigger: 'blur' },
          ],
        }
      });
      const ruleForm = ref()
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      //选择省市区
      const citychange = (e) => {
        form.value.province = e[0]
        form.value.city = e[1]
        form.value.area = e[2]
      }
      // 获取行业列表
      const getType = async () => {
        let res = await getIndustry().then(res => res.data);
        if (iscode(res)) {
          state.typeList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      //获取详情
      const getMore = async (id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getInfoDetail().then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          state.address = [res.data.province, res.data.city, res.data.region]
          setTimeout(hide);
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          delete form.value.create_time
          delete form.value.update_time
          let res = await setInfoUpdate(form.value).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            let userInfo = store.state.user.info;
            userInfo.overView.brand_logo = form.value.brand_logo
            store.dispatch('user/setUserInfo', userInfo);
            message.success(res.msg);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        getType();
        getMore();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        confirm,
        citychange
      }
    }
  }
</script>
